(function () {
  const OPTIMIZED_CLASS = 'rollator-pdp-optimized';
  const BRIDGE_SELECTOR = '[data-rollator-lcp-bridge]';
  const MEDIA_ROOT_SELECTOR = '[data-rollator-media-root]';
  // Match either the native variant gallery (active slide image) or the
  // legacy ProductWiz swiper (kept temporarily for safe rollback).
  const ACTIVE_IMAGE_SELECTOR = [
    'media-gallery .product__media-item.is-active img',
    'media-gallery li.is-active img',
    '#pwzrswiper-img-0',
    '.pwzrswiper-slide-active img',
    '.pwzrswiper-lazy-loaded',
  ].join(', ');
  const MAX_BRIDGE_DURATION = 5000;

  if (!document.body || !document.body.classList.contains(OPTIMIZED_CLASS)) return;

  const bridge = document.querySelector(BRIDGE_SELECTOR);
  if (!bridge) return;

  const mediaRoot = document.querySelector(MEDIA_ROOT_SELECTOR) || document.documentElement;
  let hidden = false;
  let observer = null;
  let timer = null;
  let readyFrames = 0;

  function hideBridge() {
    if (hidden) return;
    hidden = true;
    bridge.classList.add('is-hidden');
    if (observer) observer.disconnect();
    if (timer) window.clearTimeout(timer);
  }

  function activeImageReady() {
    const image = mediaRoot.querySelector(ACTIVE_IMAGE_SELECTOR);
    if (!image) return false;

    const rect = image.getBoundingClientRect();
    const style = window.getComputedStyle(image);
    const hasLoadedSource = Boolean(image.currentSrc || image.src);
    const hasImageData = image.complete && image.naturalWidth > 0;
    const isVisible =
      rect.width >= 120 &&
      rect.height >= 120 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity) !== 0;

    return hasLoadedSource && hasImageData && isVisible;
  }

  function checkReady() {
    if (!activeImageReady()) {
      readyFrames = 0;
      return;
    }

    readyFrames += 1;
    if (readyFrames >= 2) {
      hideBridge();
      return;
    }

    window.requestAnimationFrame(checkReady);
  }

  checkReady();

  observer = new MutationObserver(checkReady);
  observer.observe(mediaRoot, {
    attributes: true,
    attributeFilter: ['class', 'src'],
    childList: true,
    subtree: true,
  });

  timer = window.setTimeout(hideBridge, MAX_BRIDGE_DURATION);
})();

(function () {
  const OPTIMIZED_CLASS = 'rollator-pdp-optimized';
  const MEDIA_ROOT_SELECTOR = '[data-rollator-media-root]';
  const PRODUCTWIZ_IMAGE_SELECTOR = 'img[id^="pwzrswiper-img-"]';
  const PRODUCTWIZ_IMAGE_SIZE = '720';
  const OBSERVER_DURATION = 12000;

  if (!document.body || !document.body.classList.contains(OPTIMIZED_CLASS)) return;

  const mediaRoot = document.querySelector(MEDIA_ROOT_SELECTOR) || document.documentElement;
  let observer = null;
  let timer = null;

  function stabilizeImage(image) {
    if (!image || image.nodeType !== Node.ELEMENT_NODE) return;
    if (!image.matches(PRODUCTWIZ_IMAGE_SELECTOR)) return;

    if (!image.hasAttribute('width')) image.setAttribute('width', PRODUCTWIZ_IMAGE_SIZE);
    if (!image.hasAttribute('height')) image.setAttribute('height', PRODUCTWIZ_IMAGE_SIZE);
    image.setAttribute('decoding', 'async');
  }

  function stabilizeImages(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;

    stabilizeImage(root);
    root.querySelectorAll?.(PRODUCTWIZ_IMAGE_SELECTOR).forEach(stabilizeImage);
  }

  function cleanup() {
    if (observer) observer.disconnect();
    if (timer) window.clearTimeout(timer);
  }

  stabilizeImages(mediaRoot);

  observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(stabilizeImages);
    });
  });

  observer.observe(mediaRoot, {
    childList: true,
    subtree: true,
  });

  timer = window.setTimeout(cleanup, OBSERVER_DURATION);
})();
